import { Box } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { Contact } from '../../../../../../model/contacts.model';
import { ContactCard } from '../ContactCard';
import { ContactDetail } from '../ContactDetail';

export function ContactsLoading({
  loading,
  setSelected,
  selected,
}: {
  loading: boolean;
  setSelected: Dispatch<SetStateAction<Contact | undefined>>;
  selected: Contact | undefined;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        marginTop: '20px',
        height: { xs: 'calc(100vh - 370px)', xl: 'calc(100vh - 420px)' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '10px', xl: '16px' },
          flex: 1,
        }}
      >
        {[1, 2, 3, 4].map((val) => (
          <ContactCard
            key={val}
            data={''}
            setSelected={setSelected}
            selected={selected}
            loading={loading}
          />
        ))}
      </Box>
      <Box sx={{ flex: 2, height: '100%' }}>
        {<ContactDetail selected={selected} loading={loading} />}
      </Box>
    </Box>
  );
}
